import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core'; 
import { MatSidenav } from '@angular/material/sidenav';
import { AuthService } from 'src/app/services/auth.service';
import { DataService } from 'src/app/services/data.service';
import { User } from 'src/app/shared/models/user';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit, OnDestroy {
  mobileQuery: MediaQueryList;
  @ViewChild('sidenav') sidenav: MatSidenav;

  
  public dashboardSideNavContent = {
    MY_ACCOUNT: 'my-account',
    CREATE_EVENT: 'create-event',
    CREATE_NOTIFICATION: 'create-notification',
    HOME: ''
  };
  
  public navLinks = [
    {
      name: 'Home',
      contentLink: this.dashboardSideNavContent.MY_ACCOUNT
    },
    {
      name: 'Eventos',
      contentLink: this.dashboardSideNavContent.CREATE_EVENT
    },
    {
      name: 'Configuración',
      contentLink: this.dashboardSideNavContent.HOME
    },
    {
      name: 'Soporte y ayuda',
      contentLink: this.dashboardSideNavContent.HOME
    },
  ];

  currentContent = this.dashboardSideNavContent.HOME;

  activeMetric = 'events';
  events: any[] = []; // Create an empty array to store events
  followers: User[] = []; // Create an empty array to store followers

  private _mobileQueryListener: () => void;

  constructor(changeDetectorRef: ChangeDetectorRef, media: MediaMatcher, 
    private dataService: DataService,
    public authService: AuthService) {
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);

  }

  toogleSidenav() {
   this.sidenav.toggle();
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  ngOnInit(): void {
    // When the component is initialized, fetch events and followers
    this.fetchEvents();
    this.fetchFollowers();
  }

  fetchEvents() {
    // Use the DataService to fetch events
    this.dataService.getEventsFromUser(this.authService.userData.brandId).then((res)=>{
      console.log('');
      console.log('');
      console.log('res ', res );
      console.log('');
      console.log('');
    }).catch((e)=>{
      console.log('e ', e);
    })
  }

  fetchFollowers() {
    // Use the DataService to fetch followers
    this.dataService.getFollowersFromUser(this.authService.userData.brandId).then((res) => {
      console.log('');
      console.log('');
      console.log('users ', res );
      console.log('');
      console.log('');
    }).catch((e)=>{
      console.log('e ', e);
    })
  }
}